module.exports = __webpack_public_path__ + "static/icons/icon-clipboard--black-c71d97f583e53c5314684909c4e991e7.svg";